import React from 'react';
import PropTypes from 'prop-types';

import { findDOMNode } from 'react-dom';
import Dropdown from '@ott/dropdown';

import setRefs from '../utilities/setRefs';

import cls from 'classnames/bind';
import styles from './CardDropdown.scss';
const cx = cls.bind(styles);

class CardDropdown extends Dropdown {
  static propTypes = {
    ...Dropdown.propTypes,
    disableManualInput: PropTypes.bool.isRequired,
    buttonContent: PropTypes.node,
    optionalButtonHandler: PropTypes.func,
    disabled: PropTypes.bool,
  };

  static defaultProps = {
    ...Dropdown.defaultProps,
    buttonContent: null,
    withArrow: false,
  };

  constructor(props, ctx) {
    super(props, ctx);

    this.refsMap = {};

    this.state = {
      ...this.state,
      hasTopShadow: false,
    };
  }

  setDropdownShadowsState = (e, ...args) => {
    const scrollWrapperNode = (e && e.target) || findDOMNode(this.refsMap.optionsWrap);

    if (this.state.isOpen && scrollWrapperNode) {
      this.setState({
        hasTopShadow: scrollWrapperNode.scrollTop > 0,
      });
    } else {
      this.setState({
        hasTopShadow: false,
      });
    }
  };

  handleBlur = (e, ...args) => {
    const relatedTarget =
      e &&
      (e.relatedTarget /* Chrome */ ||
        e.srcElement ||
        document.activeElement /* IE */ ||
        e.explicitOriginalTarget); /* Firefox */

    const dropdownNode = findDOMNode(this.refsMap.dropdown);

    // закрывает если действия происходят не в зоне dropdown
    if (!relatedTarget || !dropdownNode || !dropdownNode.contains(relatedTarget)) {
      return super.handleBlur(e, args);
    }
  };

  handleOptionalButtonClick = (e, ...args) => {
    e.preventDefault();

    this.props.optionalButtonHandler(e, args);

    this.hideSelect();
  };

  hideSelect = (cb) => {
    this.setState({
      hasTopShadow: false,
    });

    return super.hideSelect(cb);
  };

  handleClick = (e) => {
    this.setState({
      hasTopShadow: false,
    });

    super.handleClick(e);
  };

  setRefs = setRefs(this);

  setRefOptionsWrap = this.setRefs('optionsWrap');

  setRefItemsList = this.setRefs('itemsList');

  setDropdownRef = this.setRefs('dropdown');

  render() {
    const { isOpen, hasTopShadow } = this.state;

    const { isError, buttonContent, items, disableManualInput, disabled } = this.props;

    const onScrollHandler = items && items.length > 3 ? this.setDropdownShadowsState : null;

    const optionsNodes = this.getOptions();

    const optionsListNode = optionsNodes ? (
      <div
        className={cx('items', {
          hasTopShadow,
        })}
        tabIndex="-1"
      >
        <div
          className={cx('scrollWrapper')}
          ref={this.setRefOptionsWrap}
          onScroll={onScrollHandler}
          tabIndex="-1"
        >
          <div className={cx('list')} ref={this.setRefItemsList} tabIndex="-1">
            {optionsNodes}
          </div>
        </div>
      </div>
    ) : null;

    const overlayNode = isOpen ? (
      <div
        className={cx('overlay', {
          isOpen,
        })}
      >
        {optionsListNode}
        {!disableManualInput && (
          <button
            className={cx('submitButton')}
            type="submit"
            onClick={disabled ? () => {} : this.handleOptionalButtonClick}
            onBlur={this.handleBlur}
          >
            {buttonContent}
          </button>
        )}
      </div>
    ) : null;

    return (
      <div
        className={cx('CardDropdown', {
          'CardDropdown--isOpen': isOpen,
          'CardDropdown--isError': isError,
        })}
        ref={this.setDropdownRef}
      >
        {this.renderTrigger()}
        {overlayNode}
      </div>
    );
  }
}

export default CardDropdown;
